<template>
  <section
    class="list_stories"
    :class="
      _.includes(_.get(contentData, 'conf.conf'), 'background') ? 'have-bg' : ''
    "
  >
    <div class="container-2">
      <h2 class="main-title font-34">
        {{ _.get(contentData, "conf.header.title") }}
      </h2>

      <!-- <div
        class="tags"
        v-if="!_.includes(_.get(contentData, 'conf.conf'), 'no-tags')"
        :class="startAnim ? 'no-click' : ''"
      >
        <p class="tags-text">{{ $fn.tr("Tags:") }}</p>

        <template
          v-for="(item, index) in _.get(
            this.$store.state.main.indx,
            'terms.stories_tags'
          )"
        >
          <p
            @click="ChangeStories(item)"
            class="single-tag"
            :class="{ active: item.id === currentID }"
            :key="index"
          >
            <span class="tag-text">
              {{ item.title }}
            </span>
            <span class="close-span" v-if="item.id === currentID">
              <IconComponent name="close" />
            </span>
          </p>
        </template>
      </div> -->
      <p class="err" v-if="_.get(filteredData, 'length') == 0">
        {{ $fn.tr("შედეგი ვერ მოიძებნა!") }}
      </p>
      <div
        class="grid"
        v-if="
          _.includes(_.get(contentData, 'conf.conf'), 'grid') &&
            !_.includes(_.get(contentData, 'conf.conf'), 'slider')
        "
      >
        <!-- _.get(contentData, 'data.list') -->
        <template v-for="(item, index) in filteredData">
          <StoryCard
            :data="item"
            :key="index"
            :content="_.includes(_.get(contentData, 'conf.conf'), 'grid')"
          />
        </template>
      </div>
      <center
        v-if="
          _.includes(_.get(contentData, 'conf.conf'), 'grid') &&
            !_.includes(_.get(contentData, 'conf.conf'), 'slider')
        "
      >
        <el-pagination
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="per_page_count"
          :current-page.sync="page"
          :total="list_count"
          :disabled="false"
          :hide-on-single-page="true"
          @current-change="sendData"
          :key="'pagination'"
        >
        </el-pagination>
      </center>
      <!-- 
        :class="startAnim ? 'switch-anim' : ''"

       -->
      <div
        class="stories-slider"
        v-if="_.includes(_.get(contentData, 'conf.conf'), 'slider')"
      >
        <swiper
          ref="storys"
          class="swiper-view story-swiper"
          :options="swiperOptions"
        >
          <swiper-slide
            class="story-single-slide"
            v-for="(item, index) in filteredData"
            :key="index"
          >
            <StoryCard :data="item" />
          </swiper-slide>
        </swiper>
        <div class="swiper-prev">
          <IconComponent name="slider-next" />
        </div>
        <div class="swiper-next">
          <IconComponent name="slider-next" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StoryCard from "../cards/StoriesCard.vue";
import IconComponent from "../IconComponent.vue";
import Pagination from "../Pagination.vue";
import fn from "../../helpers/func";

export default {
  props: ["contentData"],
  components: {
    StoryCard,
    IconComponent,
    Pagination
  },
  data() {
    return {
      currentID: null,
      swiperOptions: {
        speed: 800,
        navigation: {
          nextEl: ".swiper-next",
          prevEl: ".swiper-prev"
        },
        breakpoints: {
          320: {
            spaceBetween: 30,
            slidesPerView: 1.2
          },
          768: {
            spaceBetween: 15,
            slidesPerView: 1.6
          },
          1024: {
            spaceBetween: 15,
            slidesPerView: 2.6
          },
          1366: {
            spaceBetween: 30,
            slidesPerView: 3
          }
        }
      },
      _list_count: null,
      filteredList: null,
      page: 1
    };
  },
  computed: {
    filteredData() {
      if (this.filteredList) {
        return this.filteredList;
      } else {
        return _.get(this.contentData, "data.list");
      }
    },
    per_page_count() {
      return parseInt(_.get(this.contentData, "conf.page_count"))
        ? parseInt(_.get(this.contentData, "conf.page_count"))
        : 8;
    },
    get_unic_id() {
      return _.get(this.contentData, "conf.unicId");
    },
    page_size() {
      let tmp = _.get(this.contentData, "conf.page_count");
      return parseInt(tmp);
    },
    list_count() {
      if (this.filteredList) {
        return this._list_count;
      } else {
        return _.get(this.contentData, "data.listCount");
      }
    }
  },
  methods: {
    async sendData() {
      const params = {
        componentUnicId: _.get(this.contentData, "conf.unicId"),
        id: _.get(this.$store.state.main.selected_menu, "id"),
        pageNumber: this.page,
        perPage: this.per_page_count
      };
      const res = await fn.postData("main/getDataList", params);
      window.scrollTo({ top: 0, behavior: "smooth" });

      this.filteredList = res.data.list || null;
      this._list_count = res.data.listCount;
    }
  }
};
</script>
<style lang="scss">
.list_stories {
  .err {
    font-size: 24px;
    text-align: center;
  }
  margin: 89px 0;
  @media (max-width: 767px) {
    margin: 55px 0 89px;
  }
  // .container-2 {
  //   @media (max-width: 1599px) {
  //     width: unset;
  //     max-width: unset;
  //   }
  // }
  &.have-bg {
    margin: 0 0;
    padding: 89px 0;
    background: var(--thirdy-bg);
  }
  .story-swiper {
    overflow: visible;
    transition: 0.6s ease-in-out;
  }
  .no-click {
    pointer-events: none;
  }
  .switch-anim {
    opacity: 0;
    visibility: hidden;
    transition: 0.6s ease-in-out;
  }
  .main-title {
    margin-bottom: 45px;
    width: fit-content;
    color: var(--bonus-txt);
    @media (max-width: 767px) {
      font-size: 21px;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    row-gap: 55px;
    column-gap: 30px;
    @media (max-width: 1365px) {
      row-gap: 34px;
      column-gap: 35px;
    }
    @media (max-width: 1023px) {
      grid-template-columns: repeat(1, minmax(0, 1fr));
      row-gap: 55px;
    }
  }
  .stories-slider {
    position: relative;
    .swiper-next {
      position: absolute;
      top: 35%;
      right: -60px;
      z-index: 3;
      width: 60px;
      height: 40px;
      transform: translateY(-50%);
      background: var(--primary);
      border: 2px solid var(--primary-border);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 1719px) {
        right: -30px;
      }
      @media (max-width: 1599px) {
        right: -60px;
      }
      @media (max-width: 1279px) {
        display: none;
      }
    }
    .swiper-prev {
      position: absolute;
      top: 35%;
      left: -60px;
      z-index: 3;
      width: 60px;
      height: 40px;
      transform: translateY(-50%);
      background: var(--primary);
      border: 2px solid var(--primary-border);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      @media (max-width: 1719px) {
        left: -30px;
      }
      @media (max-width: 1599px) {
        left: -60px;
      }
      @media (max-width: 1279px) {
        display: none;
      }
      svg {
        transform: rotate(180deg);
      }
    }
    .swiper-button-disabled {
      opacity: 0;
      pointer-events: none;
    }
  }
  .tags {
    display: flex;
    align-items: center;
    margin-bottom: 45px;
    overflow-x: auto;
    &::-webkit-scrollbar {
      height: 1px;
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      height: 1px;
      background: transparent;
    }
    &::-webkit-scrollbar-track {
      height: 1px;
      background: transparent;
    }
    .tags-text {
      color: var(--bonus-txt);
      margin-right: 21px;
    }
    .single-tag {
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 10px;
      }
      background: var(--thirdy-second);
      border: 1px solid var(--thirdy-third);
      padding: 7px 16px;
      border-radius: 17px;
      display: flex;
      align-items: center;
      .close-span {
        position: relative;
        z-index: 2;
        cursor: pointer;
      }
      .tag-text {
        font-size: 13px;
        line-height: 16px;
        color: var(--bonus-txt);
        width: -webkit-max-content;
        width: max-content;
        cursor: pointer;
      }
      &.active {
        background: var(--secondary);
        color: var(--white-bg);
        .tag-text {
          margin-right: 10px;
          color: var(--white-bg);
        }
      }
    }
  }
}
</style>
